import React from 'react';
import TextField from "@material-ui/core/TextField";

/**
 * Reusable DateTimeLocalInput component that uses native HTML5 datetime-local input
 * Updates immediately when any part (date, hour, minute) is changed
 * Opens picker when clicking anywhere in the field
 */
const DateTimeLocalInput = ({ value, onChange, label = "Date/Time", ...otherProps }) => {
    // Convert Date to datetime-local format (YYYY-MM-DDTHH:mm)
    const formatDateForInput = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    // Parse datetime-local format back to Date
    const parseInputToDate = (inputValue) => {
        if (!inputValue) return null;
        const parsedDate = new Date(inputValue);
        return !isNaN(parsedDate.getTime()) ? parsedDate : null;
    };

    // Open the picker when clicking on the input
    const handleInputClick = (e) => {
        const input = e.currentTarget.querySelector('input[type="datetime-local"]');
        if (input) {
            if (typeof input.showPicker === 'function') {
                try {
                    input.showPicker();
                } catch (err) {
                    input.focus();
                }
            } else {
                input.focus();
            }
        }
    };

    // Open picker when field receives focus
    const handleFocus = (e) => {
        const input = e.target;
        if (input && input.type === 'datetime-local') {
            setTimeout(() => {
                if (typeof input.showPicker === 'function') {
                    try {
                        input.showPicker();
                    } catch (err) {
                        // showPicker might fail in some browsers, that's okay
                    }
                }
            }, 10);
        }
    };

    // Handle input value changes
    const handleChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue) {
            const parsedDate = parseInputToDate(inputValue);
            if (parsedDate && onChange) {
                onChange(parsedDate);
            }
        }
    };

    return (
        <TextField
            label={label}
            type="datetime-local"
            value={formatDateForInput(value)}
            onChange={handleChange}
            onFocus={handleFocus}
            variant="outlined"
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                style: { cursor: 'pointer' },
                onClick: handleInputClick
            }}
            inputProps={{
                style: { cursor: 'pointer' }
            }}
            {...otherProps}
        />
    );
};

export default DateTimeLocalInput;


